import React from 'react'
import { useState, useRef, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import { useForm } from 'react-hook-form'
import { getOrgGoal } from '../../api/OrganizationGoal/getOrgGoal'
import { ModalFooter } from 'react-bootstrap'
import { useAuthContext } from '../../hooks'
import parse from 'html-react-parser'
import Navbar from '../../Components/Navbar'
import { updateOrgGoals } from '../../api/Update/updateOrgGoals'
import { getOrgGoalType } from '../../api/OrganizationGoal/getOrgGoalType'
import ReactQuill from 'react-quill'
import { string } from 'yup/lib/locale'
import { getPeopleleadCommentForUser } from '../../api/peopleLeadPerformance/getPeopleLeadCommentForUser'
interface orgGoalFormData {
  goal_role_id: any
  due_date: string
  goal: string
}
function Index() {
  const auth = useAuthContext()
  const [orgGoals, setOrgGoals] = useState<any[]>([])

  const fetchOrgGoals = async () => {
    await getOrgGoal(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
    )
      .then((e) => {
        console.log(e)
        setOrgGoals(e)
      })
      .catch((e) => console.log(e))
  }
  const handleUserComment = async (e: any) => {
    console.debug('data > ', e)
  }

  const [getOrgGoaltype, setGetOrgGoaltype] = useState<any[]>([])
  const fetchAllOrgGoalType = async () => {
    await getOrgGoalType(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e)
        setGetOrgGoaltype(e)
      })
      .catch((e) => console.log(e))
  }
  const [show, setShow] = useState(false)

  type orgGaolProps = {
    goal: string
    GoalRole: string
    parse: string
    id: Number
    due_date: string
  }

  const [orgGoal, setOrgGoal] = useState<orgGaolProps>()
  function handleShow(data: orgGaolProps) {
    setShow(true)
    setOrgGoal(data)
  }
  console.log(orgGoal)
  const handleClose = () => {
    setShow(false)
  }
  const [orgGoalFormData, setorgGoalFormData] = useState<orgGoalFormData>({
    goal_role_id: '',
    goal: '',
    due_date: '',
  })
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setorgGoalFormData((prevorgGoalFormData: orgGoalFormData) => ({
      ...prevorgGoalFormData,
      [name]: name == 'goal_role_id' ? Number(value) : value,
    }))
  }
  const handleGoalChange = (value: string) => {
    setorgGoalFormData((prevorgGoalFormData: any) => ({
      ...prevorgGoalFormData,
      goal: value,
    }))
  }
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      const response = await updateOrgGoals(
        auth?.userInfo?.orgs[0]?.id,
        auth?.userInfo?.orgs_user_id[0],
        orgGoal?.id,
        orgGoalFormData,
      )
      console.log(response)

      setorgGoalFormData({ goal_role_id: '', goal: '', due_date: '' })
      setShow(false)
      fetchOrgGoals()
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchAllOrgGoalType()
    fetchOrgGoals()
  }, [])
  console.log(getOrgGoaltype)
  return (
    <>
      <div className="user-goal-main">
        <label>Org Goals</label>
        {orgGoals.length > 0 ? (
          orgGoals?.map((data) => {
            return (
              <>
                <div className="user-gaol-title-main">
                  <div>Goal type:{data?.GoalRole}</div>
                  <div>Due Date : {data?.due_date}</div>
                </div>
                <div className="project-goals-main">
                  <div className="user=goal-title">{parse(data?.goal)}</div>
                  <Button
                    className="goal-edit-button"
                    onClick={() => handleShow(data)}
                  >
                    Edit Goal
                  </Button>
                </div>
              </>
            )
          })
        ) : (
          <div>*No Organization Goals Found*</div>
        )}
      </div>
      <Modal
        id="AddRpm"
        className="modal-objective"
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        height="100"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">Apply PPM</Modal.Title>
          <button
            className="modal-close-button"
            onClick={() => {
              handleClose()
            }}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="objective-modal">
              <div className="evaluation-objective-container">
                <label>Previuos Org Goals:</label>
                {orgGoal && parse(String(orgGoal?.goal))}
                <label>Org Goal Type:</label>
                {orgGoal?.GoalRole}
                <label>Due Date:</label>
                {orgGoal?.due_date}
                <div className="evaluation-container">
                  <label>Org Goals</label>
                  <select onChange={handleChange} name="goal_role_id">
                    <option value="">Select Org Goals</option>
                    {getOrgGoaltype?.map((data: any) => {
                      return (
                        <>
                          <option value={parseInt(data?.id)}>
                            {data?.name}
                          </option>
                        </>
                      )
                    })}
                  </select>
                  <label>Due Date:</label>
                  <input
                    className="due-dates"
                    type="date"
                    value={orgGoalFormData?.due_date}
                    onChange={handleChange}
                    name="due_date"
                  />
                </div>
              </div>
              <ReactQuill
                defaultValue={String(orgGoal?.goal)}
                onChange={handleGoalChange}
              />

              <button type="submit" className="objective-submit">
                Submit
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Index
